module.exports = __webpack_public_path__ + "img/logo-bouygues-telecom-entreprises.7fc04a93.png";